import React, { useState } from "react";
import { Carousel, Modal } from "react-bootstrap";
import "swiper/css";

function Carrusel({ images, className = "" }) {
	const [showModal, setShowModal] = useState(false);
	const [currentIndex, setCurrentIndex] = useState(0);

	// Abre el modal y establece la imagen actual
	const handleShow = (index) => {
		setCurrentIndex(index);
		setShowModal(true);
	};

	// Cambia de imagen en el modal (anterior y siguiente)
	const handlePrev = () => {
		setCurrentIndex((prevIndex) =>
			prevIndex === 0 ? images.length - 1 : prevIndex - 1
		);
	};

	const handleNext = () => {
		setCurrentIndex((prevIndex) =>
			prevIndex === images.length - 1 ? 0 : prevIndex + 1
		);
	};

	return (
		<>
			{/* Carrusel principal */}
			<Carousel className={`contenedor-imagen ${className}`}>
				{images.map((src, index) => (
					<Carousel.Item key={index} className="carousel-item-custom">
						<div className="texto-flotante">VENTA</div>
						<img
							src={src}
							alt={`Imagen ${index + 1}`}
							className={`d-block img-fluid imagen-contenedor-imagen-1 imagen-${className}`}
							loading="lazy"
							onClick={() => handleShow(index)} // Click para expandir
							style={{ cursor: "pointer" }}
						/>
					</Carousel.Item>
				))}
			</Carousel>

			{/* Modal con slider */}
			<Modal
				show={showModal}
				onHide={() => setShowModal(false)}
				centered
				className="modal-slider"
			>
				<Modal.Body className="modal-body-slider position-relative">
					{/* Botón para cerrar el modal */}
					<button className="btn-cerrar-modal" onClick={() => setShowModal(false)}>
						&times;
					</button>

					{/* Slider manual dentro del modal */}
					<div className="image-container">
						<img
							src={images[currentIndex]}
							alt={`Imagen ampliada ${currentIndex + 1}`}
							className=" img-scalable"
						/>
					</div>
					<div className="d-flex justify-content-between mt-3 gap-3 ">
						<button
							className="btn btn-secondary btn-antes-despues btn-secondary-small"
							onClick={handlePrev}
						>
							Anterior
						</button>
						<button
							className="btn btn-secondary btn-antes-despues btn-secondary-small"
							onClick={handleNext}
						>
							Siguiente
						</button>
					</div>
				</Modal.Body>
			</Modal>
		</>
	);
}

export default Carrusel;
